<template>
    <div class="table-scroll">
        <table class="badges-table">
            <thead>
                <tr>
                    <th>Badge</th>
                    <th>Numéro</th>
                    <th>Chauffeur associé</th>
                    <th>Véhicules associés</th>
                    <th>État</th>
                    <th>Dernière activité</th>
                    <th v-if="canManage" class="actions-heading">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="badge in badges" :key="badge.id" :data-badge-id="String(badge.id)"
                    :class="{ selected: String(selectedId) === String(badge.id) }">
                    <td>
                        <div class="identity">
                            <div class="avatar" aria-hidden="true">▣</div>
                            <div class="identity-text"><strong>{{ badge.ref || 'Sans référence' }}</strong><small>Slot
                                    balise : {{ badge.slot != null ? badge.slot : '—' }}</small></div>
                        </div>
                    </td>
                    <td class="number">{{ badge.number || '—' }}</td>
                    <td><span v-if="badge.driverId && badge.driver" class="driver-name">{{
                        [badge.driver.firstName, badge.driver.lastName].filter(Boolean).join(' ') || 'Chauffeur #' +
                        badge.driverId }}</span><span v-else-if="badge.driverId" class="driver-name">Chauffeur #{{
                                badge.driverId }}</span><span v-else class="unassigned">Non attribué</span></td>
                    <td>
                        <div v-if="badge.balises?.length" class="badge-vehicles">
                            <VehicleMiniLink v-for="balise in badge.balises" :key="balise.id" :balise="balise" />
                        </div>
                        <span v-else class="unassigned">Aucun véhicule</span>
                    </td>
                    <td><span class="status"
                            :class="badge.status === 'ACTIVE' ? 'active' : (badge.status === 'NEW' ? 'pending' : 'inactive')"><span
                                class="dot"></span>{{ badge.status === 'NEW' ? 'À valider' : (badge.status === 'ACTIVE'
                                    ? 'Actif' : 'Désactivé') }}</span></td>
                    <td class="last-activity">{{ formatLastActivity(badge.lastActivity) }}</td>
                    <td v-if="canManage" class="action-cell"><button type="button"
                            :aria-expanded="selectedId != null && String(selectedId) === String(badge.id)"
                            @click="$emit('edit', badge, $event)">Modifier <span aria-hidden="true">→</span></button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import VehicleMiniLink from '@/components/display/VehicleMiniLink.vue';

export default {
    name: 'BadgeList',
    components: { VehicleMiniLink },
    props: { badges: { type: Array, required: true }, canManage: { type: Boolean, default: false }, selectedId: { type: [Number, String], default: null } },
    emits: ['edit'],
    methods: {
        formatLastActivity(value) {
            if (!value) return 'Jamais';
            const date = new Date(value);
            if (Number.isNaN(date.getTime())) return '—';
            return date.toLocaleString('fr-FR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        }
    }
};
</script>
<style scoped>
.table-scroll {
    width: 100%;
    overflow-x: auto;
}

.badges-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
}

th {
    background: #fbfcfe;
    color: #7c8799;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: .08em;
    padding: 15px 25px;
    white-space: nowrap;
    font-weight: 800;
}

td {
    border-top: 1px solid #edf0f5;
    padding: 17px 25px;
    font-size: 13px;
}

tr:hover td {
    background: #f9fbfe;
}

tr.selected td {
    background: #f2f7ff;
}

.identity {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 150px;
}

.avatar {
    background: #eaf0fa;
    color: #2a558d;
    border-radius: 12px;
    height: 41px;
    width: 41px;
    display: grid;
    place-items: center;
    font-weight: 800;
    font-size: 21px;
    flex: none;
}

.identity-text {
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.identity-text strong {
    color: #202e44;
}

.identity-text small {
    color: #697b92;
    font-size: 12px;
}

.number {
    color: #53647c;
    font-variant-numeric: tabular-nums;
    overflow-wrap: anywhere;
}

.driver-name {
    color: #263e60;
    font-weight: 650;
}

.unassigned {
    color: #9ba6b5;
}

.status {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    border-radius: 99px;
    padding: 6px 10px;
    font-size: 11px;
    font-weight: 750;
    white-space: nowrap;
}

.active {
    color: #17794b;
    background: #eaf7f0;
}

.inactive {
    color: #677488;
    background: #eef1f5;
}

.pending {
    color: #93600e;
    background: #fff3d7;
}

.dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
}

.action-cell,
.actions-heading {
    text-align: right;
}

.action-cell button {
    border: 0;
    background: none;
    color: #1f569b;
    font-weight: 750;
    cursor: pointer;
    padding: 8px;
    white-space: nowrap;
}

.action-cell button:hover {
    text-decoration: underline;
}

.last-activity {
    color: #53647c;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
}

.badge-vehicles {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    min-width: 170px;
    max-width: 330px;
}

.badge-vehicles :deep(.vehicle-mini-link) {
    max-width: 100%;
}

@media(max-width:620px) {

    th,
    td {
        padding: 14px 13px;
    }
}
</style>
